/**
 * Mirrors legacy AdminController.checkPrivileges for gold-sync tab visibility.
 * Supports privileged_sso_list as array, JSON array string, or delimited string.
 */
export function isSsoOnPrivilegedList(ssoId: string, privilegedList: unknown): boolean {
  if (!ssoId || privilegedList == null) {
    return false;
  }

  if (Array.isArray(privilegedList)) {
    return privilegedList.some((entry) => String(entry).trim() === ssoId);
  }

  const raw = String(privilegedList).trim();
  if (!raw) {
    return false;
  }

  if (raw.startsWith('[')) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.some((entry) => String(entry).trim() === ssoId);
      }
    } catch {
      // fall through to legacy string.includes
    }
  }

  if (raw.includes(ssoId)) {
    return true;
  }

  return raw
    .split(/[,;\s|]+/)
    .map((s) => s.trim())
    .filter(Boolean)
    .includes(ssoId);
}
